import PropTypes from 'prop-types';
import React from 'react';

import { PlayTriangle } from 'components/Icon';
import IconButton from 'components/IconButton';
import I18n from 'utils/I18n';
import { cn } from 'utils/Tailwind';

const PlayButton = ({ onClick, className }) => (
  <div className={cn('PlayButton', className)}>
    <IconButton
      onClick={onClick}
      className="group/play-button h-12 rounded-full !bg-black !px-6 !py-3 transition-colors hover:!bg-white"
    >
      <PlayTriangle width={12} className="mr-3 w-3 group-hover/play-button:invert" />
      <span className="text-sm/1 font-medium uppercase tracking-widest text-white transition-colors group-hover/play-button:text-black">
        {I18n.localize('dasherLandingPage.playButton')}
      </span>
    </IconButton>
  </div>
);

PlayButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default PlayButton;
